var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreyAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.23828C8.36819 2.23828 8.66667 2.53676 8.66667 2.90495V7.57161H13.3333C13.7015 7.57161 14 7.87009 14 8.23828C14 8.60647 13.7015 8.90495 13.3333 8.90495H8.66667V13.5716C8.66667 13.9398 8.36819 14.2383 8 14.2383C7.63181 14.2383 7.33333 13.9398 7.33333 13.5716V8.90495H2.66667C2.29848 8.90495 2 8.60647 2 8.23828C2 7.87009 2.29848 7.57161 2.66667 7.57161H7.33333V2.90495C7.33333 2.53676 7.63181 2.23828 8 2.23828Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyAddIcon);
export default __webpack_public_path__ + "static/media/GreyAddIcon.409f33a9ab372e02d27042ec9bb54fc5.svg";
export { ForwardRef as ReactComponent };